import * as _2022 from './2022/car-search-2022';
import * as _2023 from './2023/car-search-2023';

function init() {
  _2022.init();
  _2023.init();
}

export default { init };
